import {registerComponent} from '@helpers/vue'
import RealEstate from '@realestate/RealEstate'

registerComponent(RealEstate, 'real-estate-new')
